import React from 'react';
import {DEFAULT_NULL_VALUE} from 'common/constants';
import {useController, useFormContext} from 'react-hook-form';
import {SetValueOptions} from 'components/hook-form/helpers';
// import {useMemoRef} from 'common/hooks/useMemoRef';
import {useRegisterLabel} from 'common/context/FormContext';
import ReactFlagsSelect from 'react-flags-select';
import {Props as ReactFlagsSelectProps} from 'react-flags-select/build/components/ReactFlagsSelect';
import {FormControl, FormHelperText, InputLabel, Theme} from '@mui/material';
import {readOnlyContext} from 'common/context/ReadOnlyContext';
import classNames from 'classnames';

const sx = (theme: Theme) => ({
   /* BUTTON */
   '& .flags-select button': {
      // backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,

      '&:disabled': {
         // backgroundColor: theme.palette.action.disabledBackground,
         backgroundColor: theme.palette.background.default,
         color: theme.palette.text.disabled,
         border: `1px solid ${theme.palette.action.disabledBackground}`,
         // cursor: 'not-allowed',
      },
   },

   /* ARROW через ::after */
   '& .flags-select button::after': {
      borderTop: `6px solid ${theme.palette.text.primary}`,
   },

   /* DROPDOWN WRAPPER */
   '& .flags-select ul': {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[4],
      '& > div': {
         background: 'inherit',
      },
   },

   /* ITEM */
   '& .flags-select li': {
      '&:hover': {
         backgroundColor: theme.palette.action.hover,
      },
   },

   /* SELECTED (он ставит aria-selected) */
   '& .flags-select li[aria-selected="true"]': {
      backgroundColor: theme.palette.action.selected,
   },

   /* SEARCH INPUT */
   '& .flags-select input': {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
   },
});

type Props = {
   name: string;
   required?: boolean;
   defaultRenderValue?: string;
   className?: string;
   // @deprecated use disabled prop instead
   enabled?: boolean;
   label?: string;
} & Partial<ReactFlagsSelectProps>;

const ReactFlagsSelectForm = (props: Props) => {
   const {
      name,
      defaultRenderValue = DEFAULT_NULL_VALUE,
      enabled = true,
      required,
      className,
      disabled,
      fullWidth = true,

      ...otherProps
   } = props;
   const label = props.label || props.placeholder;

   const {setValue} = useFormContext();
   useRegisterLabel(name, otherProps.label);

   const {
      field: {onChange: fieldOnChange, onBlur, value, ref},
      fieldState: {error: _error},
   } = useController({
      name,
      // rules: {required: true},
      // defaultValue: '',
   });

   const disable = disabled || !enabled;

   const error = _error?.message;

   // const _ref = useMemoRef(ref);
   const readOnly = React.useContext(readOnlyContext);
   const labelId = `${name}_id`;

   return (
      <FormControl
         fullWidth={fullWidth}
         variant={'outlined'}
         required={required}
         error={!!error}
         className={className}
         disabled={disabled || readOnly}
         sx={sx}
      >
         <InputLabel shrink={true} id={labelId}>
            {label}
         </InputLabel>
         <ReactFlagsSelect
            selected={value}
            className="flags-select"
            onSelect={(code) => {
               console.debug('select country: ', code);
               setValue(name, code, SetValueOptions);
            }}
            searchable
            // onChange={onChange} // send value to hook form
            // value={value} // input value
            // name={name} // send down the input name
            // ref={_ref} // send input ref, so we can focus on input when error appear
            // error={_error?.message}
            disabled={disable}
            label={label}
            {...otherProps}
            // onChange={_onChange}
         />
         {error ? <FormHelperText>{error}</FormHelperText> : null}
      </FormControl>
   );
};

export default React.memo(ReactFlagsSelectForm);
